export default state => state.category?.breadcrumbs;
